module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"stats":"Statistik"},"en":{"stats":"Stats"}}')
  delete Component.options._Ctor
}
